/**
 * ID Generator
 * Creates unique identifiers for consultations and records
 */

/**
 * Generate a unique ID with an optional prefix
 * Format: PREFIX_TIMESTAMP_RANDOM
 */
export function generateId(prefix: string = "ID"): string {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 9);
  return `${prefix}_${timestamp}_${random}`.toUpperCase();
}

/**
 * Generate a consultation ID
 */
export function generateConsultationId(): string {
  return generateId("CONSULT");
}

/**
 * Generate an audit record ID
 */
export function generateAuditId(): string {
  return generateId("AUDIT");
}
